import {TextNode} from 'lexical';
import {addClassNamesToElement} from '@lexical/utils';

const IS_TOKEN = 1;
const DATA_ENTITY_TYPE = 'MERGE_FIELD';

export class MergeFieldNode extends TextNode {
  constructor(text, dataKey, key, assignee, color) {
    super(text, key);
    this.__dataKey = dataKey;
    this.__mode = IS_TOKEN;
    this.__assignee = assignee || '';
    this.__color = color || '';
  }

  get entityType() {
    return DATA_ENTITY_TYPE;
  }

  static getType() {
    return 'merge-field';
  }

  static clone(node) {
    return new MergeFieldNode(node.__text, node.__dataKey, node.__key, node.__assignee, node.__color);
  }

  createDOM(config) {
    const element = super.createDOM(config);
    element.setAttribute('data-entity-type', this.entityType);
    element.setAttribute('data-key', this.__dataKey);
    element.setAttribute('data-assignee', this.__assignee);
    element.setAttribute('data-color', this.__color);
    element.style.backgroundColor = this.__color;
    addClassNamesToElement(element, this.getType());
    return element;
  }

  static importJSON(serializedNode) {
    const node = $createMergeFieldNode(
      serializedNode.text,
      serializedNode.dataKey,
      serializedNode.assignee,
      serializedNode.color
    );
    node.setFormat(serializedNode.format);
    node.setDetail(serializedNode.detail);
    node.setMode(serializedNode.mode);
    node.setStyle(serializedNode.style);
    return node;
  }

  exportJSON() {
    return {
      detail: this.getDetail(),
      format: this.getFormat(),
      mode: this.getMode(),
      style: this.getStyle(),
      text: this.getTextContent(),
      type: this.getType(),
      dataKey: this.__dataKey,
      assignee: this.__assignee,
      color: this.__color
    };
  }

  static importDOM() {
    return {
      span: (node) => {
        if (node.getAttribute('data-entity-type') === DATA_ENTITY_TYPE) {
          return {
            conversion: convertMergeFieldElement,
            priority: 4
          };
        }
        return null;
      }
    };
  }
}

function convertMergeFieldElement(domNode) {
  let textContent = domNode.textContent || '';
  let dataKey = domNode.getAttribute('data-key');
  let assignee = domNode.getAttribute('data-assignee');
  let color = domNode.getAttribute('data-color');

  return {
    node: $createMergeFieldNode(textContent, dataKey, assignee, color)
  };
}

export function $createMergeFieldNode(text, dataKey, assignee, color) {
  return new MergeFieldNode(text, dataKey, null, assignee, color);
}

export function $isMergeFieldNode(node) {
  return node instanceof MergeFieldNode;
}
